// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:12:18.212Z
// Property: Alpine (ID: 6767906449167167)
// Collections: 30 amenities, 5 floorplans (live), 18 photos, 75 POIs, 4 reviews, 4 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167167",
  "property_external_id": "1101825",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/alpine/5Xmvms/",
  "property_apartments_url": "https://www.apartments.com/alpine-anchorage-ak/znbtfdy/",
  "property_google_business_url": "https://www.google.com/maps/place/Alpine+Apartment/data=!4m2!3m1!1s0x0:0x2be1708f742952a1?sa=X&ved=2ahUKEwibwajV5IOTAxXHKlkFHV0hHz4Q_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47607381886",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "alpine-apartments",
  "property_name": "Alpine",
  "property_website_url": "https://alaska.weidner.com/apartments/ak/anchorage/alpine-0/",
  "property_domain": "https://www.alpineapartmenthomes.com",
  "property_address": "5215 Mockingbird Dr",
  "property_full_address": "5215 Mockingbird Dr, Anchorage, AK 99507",
  "property_address_1": "5215 Mockingbird Dr",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": null,
  "property_address_zip": "99507",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Campbell Park",
  "property_address_latitude": "61.17255229999999",
  "property_address_longitude": "-149.8545997",
  "property_email": "alpine@weidner.com",
  "property_phone": "(907) 308-2962",
  "property_call_tracking_phone": "907-308-2962",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Alpine Apartments, where modern living meets breathtaking views of the Chugach Mountains. Choose from studio, one, or two-bedroom floor plans, complemented by exceptional amenities like a 24-hour fitness center, dog park, and reservable clubhouse. Finding your perfect home in Anchorage has never been easier—explore our availability today!",
  "property_long_description": "Welcome to Alpine Apartments, your premier destination for modern living in the picturesque city of Anchorage, AK! Our meticulously designed community offers a variety of floor plans, including cozy Studios, spacious One-Bedroom, and inviting Two-Bedroom apartments, catering to all lifestyles and preferences. \n\nDive into a world of convenience and comfort with our exceptional amenities. Experience peace of mind with 24-Hour Emergency Maintenance and on-site management, ensuring your needs are met around the clock. Stay productive at our fully-equipped Business Center and WiFi Café or unwind at our Resident Lounge, complete with a coffee station for your daily pick-me-up. Get your heart pumping at our 24-Hour Fitness Center, featuring state-of-the-art cardio machines.\n\nFor those who love the outdoors, our Community Garden and enclosed Dog Park offer perfect spots for relaxation. Enjoy beautiful Alaskan views from select apartments equipped with air conditioning, ceiling fans, and bay windows. Our controlled access buildings provide an additional layer of security while you enjoy your smoke-free living space. Plus, with convenient online payments and service requests, managing your home has never been easier.\n\nAlpine Apartments also offer furnished units in select homes—ideal for those who crave a hassle-free moving experience. With a reservable clubhouse, laundry facilities, and ample storage options, we have everything you need right at your doorstep.\n\nDon't miss out on calling Alpine Apartments your new home! Browse our availability or schedule a tour today to discover your next living experience. Your perfect Alaskan home awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0427-716b-8a73-3da805a3abf7.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with sofa, armchair, coffee table, and large window.",
    "public_id": "019d021b-0427-716b-8a73-3da805a3abf7",
    "storage_key": "property/6767906449167167/019d021b-0427-716b-8a73-3da805a3abf7.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "387",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": "41",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.41602067183463",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/alpine-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/alpine-0/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/alpine-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404b-2fe4-759c-a37e-f3bc5cb5054e.webp",
  "property_primary_logo_media": {
    "alt_text": "Alpine Apartments logo with an eagle silhouette.",
    "public_id": "01a1404b-2fe4-759c-a37e-f3bc5cb5054e",
    "storage_key": "property/6767906449167167/01a1404b-2fe4-759c-a37e-f3bc5cb5054e.webp",
    "width": 93,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404b-7caa-754e-9b64-5b25a4ba34b3.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a1404b-7caa-754e-9b64-5b25a4ba34b3",
    "storage_key": "property/6767906449167167/01a1404b-7caa-754e-9b64-5b25a4ba34b3.webp",
    "width": 93,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404b-7023-764a-bda6-5073522ac2dd.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a1404b-7023-764a-bda6-5073522ac2dd",
    "storage_key": "property/6767906449167167/01a1404b-7023-764a-bda6-5073522ac2dd.webp",
    "width": 93,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#6B6B6B",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#231F20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 840",
  "property_sqft_min": "444",
  "property_sqft_max": "840",
  "property_price_range": "1320 - 2635",
  "property_price_min": "1320",
  "property_price_max": "2635",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/AlpineApartmentsAK",
  "property_instagram_url": "https://www.instagram.com/alpineapthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSTJaq5-XyFYRoVIpdI9w4Ss",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Alpine Apartments",
  "property_home_romance_title": "Find Your Heart's Home in Our Community Today!",
  "property_home_amenities_blurb": "Welcome to Alpine Apartments in Anchorage, AK, where modern living meets serene comfort. Choose from studio, one- or two-bedroom floor plans, designed with stunning Chugach Mountain views and community-centric amenities. Enjoy our 24-hour fitness center, dog park, and resident lounge—all tailored for your lifestyle. Transform your living experience today!",
  "property_home_floorplans_blurb": "At Alpine Apartments in the heart of Anchorage, AK, your ideal home awaits. With a variety of thoughtfully designed floor plans, each space harmonizes comfort and style amid stunning natural surroundings. Browse our available apartments to find the perfect fit for your lifestyle and embrace the vibrant community.",
  "property_home_gallery_blurb": "Welcome to Alpine Apartments in scenic Anchorage, AK, where your perfect home awaits. Choose from stylish studio, one, or two-bedroom layouts, complete with stunning mountain views and optional furnishings. Enjoy unparalleled amenities like a 24-hour fitness center, community garden, and dog park. Picture yourself living here—your new adventure starts now!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Anchorage, Alpine Apartments offer a vibrant lifestyle surrounded by a wealth of attractions. Unwind at nearby parks, delve into art at the Anchorage Museum, or engage with nature at the Alaska Botanical Garden. Just minutes from the University of Alaska Anchorage, your adventure awaits!",
  "property_home_reviews_blurb": "At Alpine Apartments in Anchorage, AK, residents rave, \"The stunning mountain views and welcoming community make every day special.\" Experience the perfect blend of comfort and nature. Curious about daily life here? Dive into firsthand accounts from our residents and see why they love calling Alpine home!",
  "property_neighborhood_blurb": "At Alpine Apartments in Anchorage, AK, enjoy a vibrant community surrounded by captivating parks, enriching museums, and educational institutions like the University of Alaska Anchorage. Venture to Earthquake Park or the Alaska Botanical Garden for nature escapes, and discover local favorites that enhance your lifestyle. See what’s around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Alpine Apartments in Anchorage, AK, enjoy an active lifestyle with 24-hour fitness, a community garden, and scenic views of the Chugach Mountains. Our thoughtfully designed studio, one, and two-bedroom apartments feature modern comforts, from ceiling fans to fully equipped kitchens. Embrace a vibrant community that prioritizes your convenience and well-being.",
  "property_applynow_blurb": "At Alpine Apartments in Anchorage, AK, enjoy a blend of comfort and convenience with studio, one, and two-bedroom floor plans. Relish our stunning mountain views, spacious courtyards, and state-of-the-art fitness center. With 24-hour maintenance and thoughtful amenities, your new home awaits—lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Alpine Apartments in Anchorage, AK, your perfect home awaits! Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, each tailored for comfort and style. Ready to take the next step? Have questions? Contact our leasing team today and let us help you find your ideal living space!",
  "property_faqs_blurb": "At Alpine Apartments in Anchorage, AK, we offer a range of thoughtfully designed floor plans—including cozy studios and spacious one and two-bedroom options. Have questions? Dive into our FAQs page for insights about our vibrant community and all the amenities that await you! Your new home is just a click away.",
  "property_floorplans_blurb": "At Alpine Apartments in Anchorage, AK, your ideal living space awaits! Whether you crave the cozy charm of a studio or the spacious comfort of a two-bedroom, our diverse floor plans cater to every lifestyle. Browse our available apartment homes and envision your future today!",
  "property_gallery_blurb": "At Alpine Apartments in Anchorage, AK, we blend comfort and convenience with stunning Chugach Mountain views. Imagine relaxing in our community garden, energizing at the 24-hour fitness center, or enjoying amenities like a resident lounge and dog park. Picture yourself living here, where your dream lifestyle awaits!",
  "property_interactivemap_blurb": "At Alpine Apartments in Anchorage, AK, choose from spacious studio, one-bedroom, and two-bedroom floor plans. With premium amenities like a 24-hour fitness center, tranquil community garden, and breathtaking views of the Chugach Mountains, your new home awaits. Utilize our interactive community map to find your perfect space today!",
  "property_pets_blurb": "At Alpine Apartments in Anchorage, AK, furry friends are part of the family! With a welcoming pet policy, you can bring up to two cats or dogs to enjoy our beautiful community. Experience the joy of living alongside your beloved companions in a space designed for comfort and adventure.",
  "property_referafriend_blurb": "At Alpine Apartments in Anchorage, AK, our diverse floor plans—studio, one-bedroom, and two-bedroom—cater to every lifestyle. Share the joy of our vibrant community with a friend, and enjoy all the perks of living in a place where great friends make great neighbors. Spread the word today!",
  "property_residentaccess_blurb": "Welcome to Alpine Apartments in Anchorage, AK, where your ideal living space awaits. Choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans tailored for comfort. Enhance your community experience by accessing the resident portal for effortless rent payments and maintenance requests—convenience is just a click away!",
  "property_reviews_blurb": "Nestled in the heart of Anchorage, Alpine Apartments are loved by residents for their stunning mountain views and welcoming atmosphere. One resident raves, “The sense of community here is truly remarkable!” See what our residents have to say about living at our vibrant community and experience the Alpine difference!",
  "property_created_at": "1771535373256",
  "property_scheduletour_blurb": "At Alpine Apartments in Anchorage, AK, your perfect home awaits! Choose from our thoughtfully designed studio, one, and two-bedroom floor plans that cater to your lifestyle. Schedule a tour today and see why our residents love living here—check out their stories and experience the Alpine difference!",
  "property_thankyou_blurb": "Thank you for reaching out to Alpine Apartments in beautiful Anchorage, AK! With charming studio, one-bedroom, and spacious two-bedroom floor plans, we have the perfect space for you. Our team is excited to connect soon and help you find your new home among the stunning Alaskan landscape!",
  "property_virtualtours_blurb": "At Alpine Apartments in picturesque Anchorage, AK, we offer a variety of thoughtfully designed floor plans, from cozy studios to spacious two-bedroom layouts. Immerse yourself in our vibrant community—take a virtual tour today and find your perfect fit among our inviting spaces!",
  "property_copyright": "2026 All Rights Reserved. Alpine Apartments",
  "property_seo_title_home": "Alpine Apartments |  Apartments in Anchorage, AK",
  "property_seo_description_home": "Discover comfort at Alpine Apartments in Anchorage! Choose from studio to two-bedroom layouts with excellent amenities. Your ideal home is here!",
  "property_seo_title_floorplans": "Floor Plans | Anchorage, AK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Alpine Apartments in Anchorage, AK. From cozy studios to spacious two-bedroom units, browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Anchorage, AK Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Alpine Apartments in Anchorage! Enjoy amenities like a dog park and fitness center in stylish studio, one, or two-bedroom homes.",
  "property_seo_title_gallery": "Gallery | Apartments in Anchorage, AK",
  "property_seo_description_gallery": "Experience life at Alpine Apartments in Anchorage! Enjoy stunning views, top amenities, and a vibrant community in our studios to two-bedroom homes.",
  "property_seo_title_virtualtours": "Virtual Tours | Alpine Apartments Apartments",
  "property_seo_description_virtualtours": "Discover comfort at Alpine Apartments, Anchorage! Explore our studio, one, and two-bedroom layouts. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Alpine Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Alpine Apartments in Anchorage! Browse our interactive map for stunning floor plans, 24/7 amenities, and breathtaking mountain views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Anchorage, AK",
  "property_seo_description_neighborhood": "Experience Anchorage at Alpine Apartments! Uncover local gems, vibrant spots, and hidden treasures just steps from your new home. Start your adventure today!",
  "property_seo_title_contact": "Contact Us | Alpine Apartments",
  "property_seo_description_contact": "Connect with Alpine Apartments in Anchorage, AK! From studios to two-bedroom layouts, our leasing team is here to answer your questions. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Find answers to all your questions about Alpine Apartments in Anchorage, AK. From amenities to floor plans, our FAQs cover everything you need to know!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Experience alpine living in Anchorage, AK! See what our residents love about Alpine Apartments—luxury amenities, stunning views, and a vibrant community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Discover modern living at Alpine Apartments in Anchorage, AK—offering diverse floor plans, great amenities, and breathtaking mountain views!",
  "property_seo_title_residentaccess": "Resident Access | Alpine Apartments",
  "property_seo_description_residentaccess": "Unlock your Alpine Apartments experience! Log in to your resident portal to pay rent, schedule maintenance, and manage your Anchorage home seamlessly.",
  "property_seo_title_referafriend": "Refer A Friend | Alpine Apartments",
  "property_seo_description_referafriend": "Unite with great neighbors at Alpine Apartments! Refer a friend and enjoy the perks of living in vibrant Anchorage, AK. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Alpine Apartments",
  "property_seo_description_scheduletour": "Experience modern living at Alpine Apartments in Anchorage, AK. Schedule a tour today and find your perfect home amid stunning mountain views!",
  "property_seo_title_privacy": "Privacy Policy | Alpine Apartments",
  "property_seo_description_privacy": "At Alpine Apartments, your privacy matters. View our policy to see how we protect your information. Check it out today!",
  "property_seo_title_accessibility": "Website Accessibility | Alpine Apartments",
  "property_seo_description_accessibility": "Enjoy seamless living at Alpine Apartments in Anchorage, AK, where digital inclusion makes accessing information easy and enjoyable for everyone.",
  "property_seo_title_sitemap": "Sitemap | Alpine Apartments",
  "property_seo_description_sitemap": "Navigate the alpine living experience in Anchorage, AK! Access our sitemap to easily find the perfect apartment and embrace a vibrant community life.",
  "property_seo_title_thankyou": "Thank You | Alpine Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Alpine Apartments in Anchorage, AK, is appreciated. We’ll be in touch shortly to help you find your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792761650383",
  "amenities": [
    {
      "id": "ec_d8d1f0db6397b88173a302fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452571",
      "title": "Business Center and Wifi Cafe",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1293faf680a79ab58747f05d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452572",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea11b1735444712b22986690",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452501",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_767980641f6c4bd8d38c32c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452502",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b0753173ec6b8dac7c84d06",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452478",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d9a32-78bb-7549-bbae-5749e22c87b8.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern fitness center with a large abstract mural on the wall.",
        "public_id": "019d9a32-78bb-7549-bbae-5749e22c87b8",
        "storage_key": "property/6767906449167167/019d9a32-78bb-7549-bbae-5749e22c87b8.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Alpine  Apartments - Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07fc0e4e95498acbd20065b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452482",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d860a56aa9471032f7f1132e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452484",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1948124dbdbc32596653aeeb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "122094001",
      "title": "Elevator in Each Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8af6adfb9097ff731acbbd6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452570",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81826d849dc5f686109057e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452470",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-7632-7208-a593-27d3d72379bd.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with a coffee station and a fireplace.",
        "public_id": "019d021b-7632-7208-a593-27d3d72379bd",
        "storage_key": "property/6767906449167167/019d021b-7632-7208-a593-27d3d72379bd.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Alpine  Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8eda4dea5c87475368b17ba9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452509",
      "title": "Community Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fd13bc8901fbf4f34bf2eae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452508",
      "title": "*Furnished Units Available in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_753c038eea03e6fd9bc7e6a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452573",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f99061fd4c13dde6117a7e41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452468",
      "title": "24-Hour Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-45b3-76ad-9faa-c7048149e34f.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washers and dryers stacked and side-by-side.",
        "public_id": "019d021b-45b3-76ad-9faa-c7048149e34f",
        "storage_key": "property/6767906449167167/019d021b-45b3-76ad-9faa-c7048149e34f.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Alpine  Apartments - Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fdf4b0f4d6547162a96dc46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452480",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c296ea8512907a50c675aef9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452507",
      "title": "Reservable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c5d551e0015549406f8d006",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452506",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-7680-720f-a229-ab73c9823f96.webp",
      "amenity_image_media": {
        "alt_text": "Spacious community lounge with high ceilings, large windows, and comfortable seating.",
        "public_id": "019d021b-7680-720f-a229-ab73c9823f96",
        "storage_key": "property/6767906449167167/019d021b-7680-720f-a229-ab73c9823f96.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Alpine  Apartments - Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85d928c210248724a3e37af5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "120672675",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2018327784f121da1cdd95dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87480552",
      "title": "Rentable Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95a9c0199f7352323ba8f63b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "124799713",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40b060a5232bd066f680e040",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452574",
      "title": "Air Conditioning*",
      "amount": "false",
      "description": "Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_196d46f5c3693bc39f8cc8a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452465",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2188ee169e4ac5c30e01ed6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452469",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "Not all studios have dishwashers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d9a32-78c7-73e8-a3ef-908031ceb4f9.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area with wooden cabinets, a dining table, and a view into a closet.",
        "public_id": "019d9a32-78c7-73e8-a3ef-908031ceb4f9",
        "storage_key": "property/6767906449167167/019d9a32-78c7-73e8-a3ef-908031ceb4f9.webp",
        "width": 1024,
        "height": 635
      },
      "amenity_image_alt_text": "Alpine  Apartments - Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c78d72cba6de56b18694a627",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452497",
      "title": "Chugach Mountain & Sleeping Lady Views*",
      "amount": "false",
      "description": "Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df0c33e0295004b3d1472bae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "88210339",
      "title": "*Furnished Units Offered in Select Homes",
      "amount": "false",
      "description": "Inquire at Leasing Office",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fef39c0724e9b8d5a0384201",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87452575",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f0aefa42cc4589faeae3d2e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87480547",
      "title": "Bay Windows*",
      "amount": "false",
      "description": "Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46fd4625fdbb57f2ff7dc641",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "87480554",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db8f2a94568ac5c781c4c97c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "126980473",
      "title": "Updated Appliances",
      "amount": "false",
      "description": "Updated Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9c634ec655047d4ef9a0bb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "external_id": "126980474",
      "title": "View Mountain",
      "amount": "false",
      "description": "View Mountain",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_99371e9a25c9689b9c2ac3d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0427-716b-8a73-3da805a3abf7.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and large window.",
        "public_id": "019d021b-0427-716b-8a73-3da805a3abf7",
        "storage_key": "property/6767906449167167/019d021b-0427-716b-8a73-3da805a3abf7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, armchair, a stylish coffee table, and a large window providing natural light.",
      "link": "false",
      "alt_text": "Living room with sofa, armchair, coffee table, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (1).jpg"
    },
    {
      "id": "ec_852331c0e8ec35588e32ca3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0260-731c-9f92-c5ea08d8ca25.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with sofa, coffee table, dining table, chairs, and kitchen appliances.",
        "public_id": "019d021b-0260-731c-9f92-c5ea08d8ca25",
        "storage_key": "property/6767906449167167/019d021b-0260-731c-9f92-c5ea08d8ca25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a functional kitchen, perfect for modern living. Includes a comfortable sofa, dining set, and essential kitchen appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen area with sofa, coffee table, dining table, chairs, and kitchen appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (2).jpg"
    },
    {
      "id": "ec_694cfb8aa2214dd96d0a4464",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0162-723c-acd3-8f0bb9761395.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with furniture and appliances.",
        "public_id": "019d021b-0162-723c-acd3-8f0bb9761395",
        "storage_key": "property/6767906449167167/019d021b-0162-723c-acd3-8f0bb9761395.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area in an apartment, featuring comfortable seating, a dining area, and a fully equipped kitchen with modern appliances. Natural light fills the space through large windows.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment with furniture and appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (3).jpg"
    },
    {
      "id": "ec_e3b0136ec58df147911ce068",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-0e94-74cf-8b4c-49a774b8ad72.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, double sink, dishwasher, and dining area.",
        "public_id": "019d021b-0e94-74cf-8b4c-49a774b8ad72",
        "storage_key": "property/6767906449167167/019d021b-0e94-74cf-8b4c-49a774b8ad72.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright kitchen featuring ample storage with wooden cabinets, a double sink, and a dishwasher. Adjacent to the kitchen is a dining area, perfect for meals.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, double sink, dishwasher, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (4).jpg"
    },
    {
      "id": "ec_426f45cd4b79fa1a5d9bcfea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-167a-756e-a4ee-608c06cc224c.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area of an apartment with a sink, dishwasher, sofa, and large windows with a view of trees.",
        "public_id": "019d021b-167a-756e-a4ee-608c06cc224c",
        "storage_key": "property/6767906449167167/019d021b-167a-756e-a4ee-608c06cc224c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment living area featuring a kitchen with a sink and dishwasher, a comfortable living room with seating, and large windows offering a scenic view.",
      "link": "false",
      "alt_text": "Kitchen and living room area of an apartment with a sink, dishwasher, sofa, and large windows with a view of trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (5).jpg"
    },
    {
      "id": "ec_ae1c4df02adbf0eb19ac75e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-1fb4-714a-979e-e93522615e2b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, decorative headboard, two nightstands, and a large mirror.",
        "public_id": "019d021b-1fb4-714a-979e-e93522615e2b",
        "storage_key": "property/6767906449167167/019d021b-1fb4-714a-979e-e93522615e2b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious bedroom, featuring a comfortable queen-size bed and ample natural light. Perfect for a peaceful retreat.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, decorative headboard, two nightstands, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (6).jpg"
    },
    {
      "id": "ec_ab19b0ec770bda2585121f05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-2399-723f-9a78-3fce0fac9d09.webp",
      "image_media": {
        "alt_text": "Bedroom with a light blue comforter on a bed, decorative pillows, a lamp, and two framed art pieces on the wall.",
        "public_id": "019d021b-2399-723f-9a78-3fce0fac9d09",
        "storage_key": "property/6767906449167167/019d021b-2399-723f-9a78-3fce0fac9d09.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush bed, decorative accents, and ample natural light from the window.",
      "link": "false",
      "alt_text": "Bedroom with a light blue comforter on a bed, decorative pillows, a lamp, and two framed art pieces on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (7).jpg"
    },
    {
      "id": "ec_a819457a3ab867b810163093",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-2697-717b-8eb3-1b66ca87761f.webp",
      "image_media": {
        "alt_text": "Bedroom with a twin bed, nightstand, and window with a view of trees.",
        "public_id": "019d021b-2697-717b-8eb3-1b66ca87761f",
        "storage_key": "property/6767906449167167/019d021b-2697-717b-8eb3-1b66ca87761f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a twin bed with a charming quilt, a wooden nightstand with a lamp, and a window offering a peaceful view of the outdoors.",
      "link": "false",
      "alt_text": "Bedroom with a twin bed, nightstand, and window with a view of trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (8).jpg"
    },
    {
      "id": "ec_47bae6df893a2810fec3a107",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-2faa-77c3-853d-efa5b8af36e6.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, toilet, and bathtub with shower curtain.",
        "public_id": "019d021b-2faa-77c3-853d-efa5b8af36e6",
        "storage_key": "property/6767906449167167/019d021b-2faa-77c3-853d-efa5b8af36e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with sink, toilet, and a bathtub/shower combination with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (9).jpg"
    },
    {
      "id": "ec_061198839efd16f2e474d4c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-3266-774f-83fa-f29d888876f0.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, vanity with sink, and mirror.",
        "public_id": "019d021b-3266-774f-83fa-f29d888876f0",
        "storage_key": "property/6767906449167167/019d021b-3266-774f-83fa-f29d888876f0.webp",
        "width": 3072,
        "height": 2115
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a bathtub and shower, a vanity with a sink, and a large mirror with ample lighting.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, shower, vanity with sink, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (10).jpg"
    },
    {
      "id": "ec_53fffd858f2351879846d789",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-370c-7519-a48d-701943296b77.webp",
      "image_media": {
        "alt_text": "A well-equipped fitness center with treadmills and elliptical machines.",
        "public_id": "019d021b-370c-7519-a48d-701943296b77",
        "storage_key": "property/6767906449167167/019d021b-370c-7519-a48d-701943296b77.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio equipment for your workout needs.",
      "link": "false",
      "alt_text": "A well-equipped fitness center with treadmills and elliptical machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (11).jpg"
    },
    {
      "id": "ec_9477c07c67860806b2ece876",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-3764-7428-97af-b3d96baa5c3c.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with fireplace, seating, and large windows.",
        "public_id": "019d021b-3764-7428-97af-b3d96baa5c3c",
        "storage_key": "property/6767906449167167/019d021b-3764-7428-97af-b3d96baa5c3c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace, comfortable seating, and abundant natural light.",
      "link": "false",
      "alt_text": "Spacious community lounge with fireplace, seating, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (12).jpg"
    },
    {
      "id": "ec_4ef3e166cbab855594e05011",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-40e5-73f6-bd4f-29b7bce71265.webp",
      "image_media": {
        "alt_text": "Lobby area with large windows, seating, and reception desk.",
        "public_id": "019d021b-40e5-73f6-bd4f-29b7bce71265",
        "storage_key": "property/6767906449167167/019d021b-40e5-73f6-bd4f-29b7bce71265.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern lobby with ample natural light, comfortable seating, and a welcoming reception area, creating a pleasant first impression.",
      "link": "false",
      "alt_text": "Lobby area with large windows, seating, and reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (13).jpg"
    },
    {
      "id": "ec_7530def64328b6c5ed7fc7ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-4598-7130-b04a-85186b66f2be.webp",
      "image_media": {
        "alt_text": "Community lounge area with coffee bar and seating.",
        "public_id": "019d021b-4598-7130-b04a-85186b66f2be",
        "storage_key": "property/6767906449167167/019d021b-4598-7130-b04a-85186b66f2be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring a convenient coffee bar and comfortable seating areas for residents to enjoy.",
      "link": "false",
      "alt_text": "Community lounge area with coffee bar and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (14).jpg"
    },
    {
      "id": "ec_f45613e605183fc9b9b7b902",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-45b3-76ad-9faa-c7048149e34f.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers stacked and side-by-side.",
        "public_id": "019d021b-45b3-76ad-9faa-c7048149e34f",
        "storage_key": "property/6767906449167167/019d021b-45b3-76ad-9faa-c7048149e34f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for resident use, featuring multiple washing and drying machines.",
      "link": "false",
      "alt_text": "Laundry room with multiple washers and dryers stacked and side-by-side.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (15).jpg"
    },
    {
      "id": "ec_e3eee3b1e12c31b045a39083",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-4fbb-75a0-b49b-75067b8d5664.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a flagpole and American flag in the foreground.",
        "public_id": "019d021b-4fbb-75a0-b49b-75067b8d5664",
        "storage_key": "property/6767906449167167/019d021b-4fbb-75a0-b49b-75067b8d5664.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community! This image showcases the exterior of our apartment buildings, complete with a prominent flagpole and American flag, set against a beautiful blue sky.",
      "link": "false",
      "alt_text": "Apartment building exterior with a flagpole and American flag in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (16).jpg"
    },
    {
      "id": "ec_ac64ca886765c1023e7fd9fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-5298-76af-912d-32e4f5d6d484.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with green grass and apartment buildings in the background.",
        "public_id": "019d021b-5298-76af-912d-32e4f5d6d484",
        "storage_key": "property/6767906449167167/019d021b-5298-76af-912d-32e4f5d6d484.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, perfect for your furry friends to run and play. Located conveniently near the apartment buildings.",
      "link": "false",
      "alt_text": "Fenced-in dog park with green grass and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (17).jpg"
    },
    {
      "id": "ec_88389842dea15807d46c045f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-52bc-7404-90c5-ba0062e4b87c.webp",
      "image_media": {
        "alt_text": "Alpine Apartments monument sign with trees and blue sky.",
        "public_id": "019d021b-52bc-7404-90c5-ba0062e4b87c",
        "storage_key": "property/6767906449167167/019d021b-52bc-7404-90c5-ba0062e4b87c.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "Welcome to Alpine Apartments. Discover our beautiful community and find your perfect home.",
      "link": "false",
      "alt_text": "Alpine Apartments monument sign with trees and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_The-Alpine_Favorites (18).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fd0519d6-d597-4bc1-b090-8455e82c99d2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Seward's Folly Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1811 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Alaskan comfort food & beer served in a relaxed setting with sports on TV & a patio.",
      "poi_long_description": "Alaskan comfort food & beer served in a relaxed setting with sports on TV & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ab-f9a2-7518-b977-80706db853fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-f9a2-7518-b977-80706db853fa",
        "storage_key": "property/6767906449167167/01a140ab-f9a2-7518-b977-80706db853fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sewardsfollybarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4051999169264824643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sewards-folly-bar--grill",
      "poi_latitude": "61.1407099",
      "poi_longitude": "-149.8466137",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-222-1218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZK6gt6ZyFYRQzE1qsaXOzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c685acbd-3b3c-4b9a-8a2a-cd2a934d12f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Bread and Brew",
      "poi_type": "Restaurants",
      "poi_address": "1450 E Tudor Rd Ste 100, Anchorage, AK 99507, USA",
      "poi_short_description": "Lively hangout with hip decor offering sandwiches, chili & other classics with 20 craft beers.",
      "poi_long_description": "Lively hangout with hip decor offering sandwiches, chili & other classics with 20 craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-00b0-7598-a476-bb2436dee364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-00b0-7598-a476-bb2436dee364",
        "storage_key": "property/6767906449167167/01a140ac-00b0-7598-a476-bb2436dee364.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://breadandbrewak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4247452362484256984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bread-and-brew",
      "poi_latitude": "61.1803049",
      "poi_longitude": "-149.8536232",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-562-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_WokqOXyFYR2JBEcmv78To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_52f1de59-0769-4276-9f74-c5e8c3f0fde1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Golden Donuts",
      "poi_type": "Restaurants",
      "poi_address": "2213 E Tudor Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Local donut shop offering a wide variety of fresh donuts and espresso.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-00ae-70e9-8e53-c2e24ddc9458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-00ae-70e9-8e53-c2e24ddc9458",
        "storage_key": "property/6767906449167167/01a140ac-00ae-70e9-8e53-c2e24ddc9458.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/Golden-Donuts-207792709291584/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10652040636279489188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-donuts",
      "poi_latitude": "61.1811881",
      "poi_longitude": "-149.8391464",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-561-8031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSrE4qaXyFYRpAJ3koWm05M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_a9d4f86d-53aa-4de2-b892-76e719319460",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Lalo's Pizza Take Out",
      "poi_type": "Restaurants",
      "poi_address": "5915 Lake Otis Pkwy #6, Anchorage, AK 99507, USA",
      "poi_short_description": "Family-run pizza restaurant serving signature pies and hearty sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-01e0-70c8-95e4-dcea5e820e5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-01e0-70c8-95e4-dcea5e820e5e",
        "storage_key": "property/6767906449167167/01a140ac-01e0-70c8-95e4-dcea5e820e5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646638834980904580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lalos-pizza-take-out",
      "poi_latitude": "61.1672331",
      "poi_longitude": "-149.8363495",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-375-9723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4b1VBnOXyFYRhF6GC-m-34U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_38c706f3-cfb2-40de-85fd-0fdcd98fed45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Thai Orchid Alaska",
      "poi_type": "Restaurants",
      "poi_address": "5905 Lake Otis Pkwy A, Anchorage, AK 99507, USA",
      "poi_short_description": "Informal, family-run eatery offering an extensive range of Thai noodles, curries & stir-fries.",
      "poi_long_description": "Informal, family-run eatery offering an extensive range of Thai noodles, curries & stir-fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ab-f99d-720d-a99e-a2a3f00d0545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-f99d-720d-a99e-a2a3f00d0545",
        "storage_key": "property/6767906449167167/01a140ab-f99d-720d-a99e-a2a3f00d0545.webp",
        "width": 1280,
        "height": 1053
      },
      "poi_business_url": "https://thaiorchidalaska.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7606197115274976236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-orchid-alaska",
      "poi_latitude": "61.1672436",
      "poi_longitude": "-149.83764190000002",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-868-5226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeVnwNKZyFYR7NuQG_qjjmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_dd65dc64-fb6a-4d27-b81d-e5f10252041b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Mo's Deli and Catering",
      "poi_type": "Restaurants",
      "poi_address": "9220 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "New York-style deli serving signature pastrami and corned beef sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-05be-7077-9e3f-49f4b1a2bb52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-05be-7077-9e3f-49f4b1a2bb52",
        "storage_key": "property/6767906449167167/01a140ac-05be-7077-9e3f-49f4b1a2bb52.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://mosdeliak.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11254154624164878926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mos-deli-and-catering",
      "poi_latitude": "61.136697100000006",
      "poi_longitude": "-149.8349723",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 229-304-7072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fb8f-70f9-847a-a4a9c1deaceb",
        "storage_key": "property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjyLZZAuZyFYRTtqq7ADKLpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_137429c4-1465-4a75-8a41-90f5d38e25e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "iluvsushi",
      "poi_type": "Restaurants",
      "poi_address": "9220 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ab-fae9-762b-a65a-b9f5faf261a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-fae9-762b-a65a-b9f5faf261a8",
        "storage_key": "property/6767906449167167/01a140ab-fae9-762b-a65a-b9f5faf261a8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800123403025421177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iluvsushi",
      "poi_latitude": "61.136477199999995",
      "poi_longitude": "-149.83483379999998",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-344-7797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZVEOxuaZyFYReZOqvIVQRds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fe241d86-2cb4-4cd0-9e02-b74a950ca779",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Boiling Pot",
      "poi_type": "Restaurants",
      "poi_address": "9220 Lake Otis Pkwy #3A, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-00bf-738a-8e62-2212cbc4b374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-00bf-738a-8e62-2212cbc4b374",
        "storage_key": "property/6767906449167167/01a140ac-00bf-738a-8e62-2212cbc4b374.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://farukh.lovable.app/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8079031698525227461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boiling-pot",
      "poi_latitude": "61.136697100000006",
      "poi_longitude": "-149.8349723",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-222-7778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcffa9uZyFYRxYm3d4Z8HnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hot_pot_restaurant"
    },
    {
      "id": "custom_fce2920b-fb6c-4941-b827-dd89a0c3b6b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Dinner Factory",
      "poi_type": "Restaurants",
      "poi_address": "5905 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ab-f9af-7568-b4a5-bb58069951ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-f9af-7568-b4a5-bb58069951ee",
        "storage_key": "property/6767906449167167/01a140ab-f9af-7568-b4a5-bb58069951ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.alaskadinnerfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11851869280820991841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-dinner-factory",
      "poi_latitude": "61.1672501",
      "poi_longitude": "-149.8372956",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-677-6633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4pfp3OXyFYRYRezJ1FMeqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_3bd687fc-0201-4742-a28b-638725a4cbb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Barbie's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6728 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ab-f8dc-71ab-a1e0-eedcb011bcaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ab-f8dc-71ab-a1e0-eedcb011bcaf",
        "storage_key": "property/6767906449167167/01a140ab-f8dc-71ab-a1e0-eedcb011bcaf.webp",
        "width": 1041,
        "height": 885
      },
      "poi_business_url": "http://www.barbiescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=81934120336670855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barbies-cafe",
      "poi_latitude": "61.159738999999995",
      "poi_longitude": "-149.83511719999998",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-344-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YgesG-XyFYRh8Cm-aUWIwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b77e3629-6cf8-4888-87c6-38926de3a61f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Serrano's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "2514 E Tudor Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Casual Mexican eatery serving scratch-made street tacos and traditional tortas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-86e4-7310-b05b-7f5ebf500f0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-86e4-7310-b05b-7f5ebf500f0f",
        "storage_key": "property/6767906449167167/019d021b-86e4-7310-b05b-7f5ebf500f0f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://serranosak.com/tudor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17814818600365081344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serranos-mexican-grill",
      "poi_latitude": "61.180534599999994",
      "poi_longitude": "-149.8333494",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-561-5611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30yjQAiXyFYRAEPITCHzOvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_956f04e7-bbec-452d-9e28-0fd506d48d6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Los Arcos | Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2000 E Dowling Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Authentic Mexican restaurant serving enchiladas, chile relleno, and margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0827-7494-a786-15defed30bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0827-7494-a786-15defed30bfe",
        "storage_key": "property/6767906449167167/01a140ac-0827-7494-a786-15defed30bfe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.losarcos-ak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4613858485605132077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-arcos--mexican-restaurant",
      "poi_latitude": "61.166188600000005",
      "poi_longitude": "-149.84510799999998",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-562-0477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8ImqXaXyFYRLWdq7ti3B0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3b9e03b6-2922-448b-8851-e600d3ad78e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Peanut Farm",
      "poi_type": "Restaurants",
      "poi_address": "5227 Old Seward Hwy, Anchorage, AK 99518, USA",
      "poi_short_description": "More than 30 beers on tap & 70+ big screens in a roomy, cabinlike sports bar with pub grub.",
      "poi_long_description": "More than 30 beers on tap & 70+ big screens in a roomy, cabinlike sports bar with pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-09ae-711b-b562-4421afba0afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-09ae-711b-b562-4421afba0afe",
        "storage_key": "property/6767906449167167/01a140ac-09ae-711b-b562-4421afba0afe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://wemustbenuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13441058489629284221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peanut-farm",
      "poi_latitude": "61.173151999999995",
      "poi_longitude": "-149.8671986",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-563-3283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yRvXqC72lYRfReah3s7iLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_4cef73c4-031d-455d-a777-05ec11ff2d95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Lahn Pad Thai",
      "poi_type": "Restaurants",
      "poi_address": "2101 Abbott Rd #7, Anchorage, AK 99507, USA",
      "poi_short_description": "Cozy family-owned standby for Thai dishes spiced to order, with fixed-price lunch deals & delivery.",
      "poi_long_description": "Cozy family-owned standby for Thai dishes spiced to order, with fixed-price lunch deals & delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-08f3-746a-a2ed-41ea93f9ddf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-08f3-746a-a2ed-41ea93f9ddf4",
        "storage_key": "property/6767906449167167/01a140ac-08f3-746a-a2ed-41ea93f9ddf4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lptak.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4059606731220113285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lahn-pad-thai",
      "poi_latitude": "61.138298",
      "poi_longitude": "-149.843428",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-272-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbZO2d2ZyFYRhdcoNtCeVjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_d8218a6a-073b-467c-8293-24dfc928bd6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Southside Bistro",
      "poi_type": "Restaurants",
      "poi_address": "1320 Huffman Park Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "An elevated New American menu & a casual bistro menu are offered at this vibrant eatery & wine bar.",
      "poi_long_description": "An elevated New American menu & a casual bistro menu are offered at this vibrant eatery & wine bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-9778-75e8-b357-41442301df74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-9778-75e8-b357-41442301df74",
        "storage_key": "property/6767906449167167/019d021b-9778-75e8-b357-41442301df74.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://southsidebistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10368335788291789318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-bistro",
      "poi_latitude": "61.109753399999995",
      "poi_longitude": "-149.8576094",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-348-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRTkk5qZyFYRBhIaNXe6448",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_23647b6d-0627-4a43-8fe2-4fbdc4dadd71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "1725 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0ad8-749b-84a8-376e9b7792a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0ad8-749b-84a8-376e9b7792a2",
        "storage_key": "property/6767906449167167/01a140ac-0ad8-749b-84a8-376e9b7792a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/1725-abbott-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968100458918547655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.142059399999994",
      "poi_longitude": "-149.8440099",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-339-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-faee-71fd-9930-370627eb2766",
        "storage_key": "property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVcl7t6ZyFYRx5AzIBBguc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_66e2a045-7afb-4614-a949-1103f4360eb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-3c1a-70b1-9dc0-be95633a6b62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-3c1a-70b1-9dc0-be95633a6b62",
        "storage_key": "property/6767906449167167/019d021c-3c1a-70b1-9dc0-be95633a6b62.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/southeast-anchorage/701/00656?cid=loc_70100656_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7143625480901027585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.135897199999995",
      "poi_longitude": "-149.8390961",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-365-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-faee-71fd-9930-370627eb2766",
        "storage_key": "property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQGYP-eZyFYRAeeIvYZBI2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2ff77cc4-d219-4554-bf1e-0202435fc127",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1501 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Chain convenience store offering prepared foods and snacks, plus coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0db6-71db-b57a-edf0224cda6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0db6-71db-b57a-edf0224cda6e",
        "storage_key": "property/6767906449167167/01a140ac-0db6-71db-b57a-edf0224cda6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/anchorage/1501-abbott-rd/2746606?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8673908847225693236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "61.1453174",
      "poi_longitude": "-149.85375710000002",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-349-2847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-5164-77dc-848b-cc36a770020e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-5164-77dc-848b-cc36a770020e",
        "storage_key": "property/6767906449167167/01a140ac-5164-77dc-848b-cc36a770020e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfxUdrtmZyFYRNGQB5SPqX3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_8800e51e-e026-4755-9a9a-8dc2d73a6b7e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "New Sagaya Midtown Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Asian-oriented grocery store featuring fresh seafood and a diverse selection of specialty international goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0dad-75fa-a213-bc1b92fffece.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0dad-75fa-a213-bc1b92fffece",
        "storage_key": "property/6767906449167167/01a140ac-0dad-75fa-a213-bc1b92fffece.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://newsagaya.com/locations/midtown-market/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283561404102005412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-sagaya-midtown-market",
      "poi_latitude": "61.187121299999994",
      "poi_longitude": "-149.869869",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-561-5173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-faee-71fd-9930-370627eb2766",
        "storage_key": "property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaYHZrmXyFYRpNImWYaL2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b13c5e59-b986-421a-970c-de8ec942a618",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Dimond Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_long_description": "Family-owned shopping center since 1977, with a bowling alley, food court, ice rink & movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-444e-77c6-9e81-57bebaa83e64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-444e-77c6-9e81-57bebaa83e64",
        "storage_key": "property/6767906449167167/01a1404c-444e-77c6-9e81-57bebaa83e64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dimondcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335366531638308692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-center",
      "poi_latitude": "61.14370340000001",
      "poi_longitude": "-149.8692814",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-344-2581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fb8f-70f9-847a-a4a9c1deaceb",
        "storage_key": "property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRVC8_E8ksiBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6bdecc46-3205-4584-928e-e9c0b3da1ea7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "330 W Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0feb-7079-9aad-692dc729f2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0feb-7079-9aad-692dc729f2c5",
        "storage_key": "property/6767906449167167/01a140ac-0feb-7079-9aad-692dc729f2c5.webp",
        "width": 1280,
        "height": 343
      },
      "poi_business_url": "https://www.costco.com/w/-/ak/anchorage/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073767655837963207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "61.1435365",
      "poi_longitude": "-149.884555",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-349-2335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fb8f-70f9-847a-a4a9c1deaceb",
        "storage_key": "property/6767906449167167/019d021b-fb8f-70f9-847a-a4a9c1deaceb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK_i7Yc2ZyFYRx5N6toBbSlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_5593f604-a00f-4dfc-967b-cf174dceab68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska International Groceries LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 W International Airport Rd #23, Anchorage, AK 99518, USA",
      "poi_short_description": "Diverse international grocery store offering halal meats and global pantry staples.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-0f1c-743a-9305-1929ea23fe6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-0f1c-743a-9305-1929ea23fe6b",
        "storage_key": "property/6767906449167167/01a140ac-0f1c-743a-9305-1929ea23fe6b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=203784344692105406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-international-groceries-llc",
      "poi_latitude": "61.173974",
      "poi_longitude": "-149.89125199999998",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-677-8776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-faee-71fd-9930-370627eb2766",
        "storage_key": "property/6767906449167167/019d021b-faee-71fd-9930-370627eb2766.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaGJTZKXyFYRvqAoJMj80wI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aa2f248d-efab-4faf-aba4-bda7268b85df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2550 E 88th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-19cd-72be-948a-28d55d25b91c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-19cd-72be-948a-28d55d25b91c",
        "storage_key": "property/6767906449167167/01a140ac-19cd-72be-948a-28d55d25b91c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2550+e+88th+ave-anchorage-ak-99507/id=15654",
      "poi_directions_map_url": "https://maps.google.com/?cid=1876399245557480173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "61.1405919",
      "poi_longitude": "-149.8352217",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-349-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswTnYeCZyFYR7bpDGCxPCho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_464b3151-2256-408d-9fd0-b7134a154d6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Tudor Elementary School",
      "poi_type": "Education",
      "poi_address": "1666 Cache Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.asdk12.org/tudor",
      "poi_directions_map_url": "https://maps.google.com/?cid=16951211670607185869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tudor-elementary-school",
      "poi_latitude": "61.1742688",
      "poi_longitude": "-149.84988149999998",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-742-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR2koL6CXyFYRzUf_-jPNPus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a15c4908-a5cb-4351-a005-b88944aa5537",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Wendler Middle School",
      "poi_type": "Education",
      "poi_address": "2905 Lake Otis Pkwy, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-112c-76fb-a5d1-2126ac703b8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-112c-76fb-a5d1-2126ac703b8b",
        "storage_key": "property/6767906449167167/01a140ac-112c-76fb-a5d1-2126ac703b8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/wendler",
      "poi_directions_map_url": "https://maps.google.com/?cid=16492933971719045852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendler-middle-school",
      "poi_latitude": "61.1937338",
      "poi_longitude": "-149.83648119999998",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPWTD86yXyFYR3EJJYBCs4uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_23040377-65d4-41fc-ae64-a8b173f6379c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Service High School",
      "poi_type": "Education",
      "poi_address": "5577 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-12cc-7103-a8c3-4681f25f6d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-12cc-7103-a8c3-4681f25f6d8f",
        "storage_key": "property/6767906449167167/01a140ac-12cc-7103-a8c3-4681f25f6d8f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/service",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278618715163057178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "service-high-school",
      "poi_latitude": "61.139031900000006",
      "poi_longitude": "-149.78129579999998",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-742-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9DYX6yQyFYRGtzBoapqZqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f9fdcf15-16a4-4ca0-88ab-8b0649e93768",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Bettye Davis East Anchorage High School",
      "poi_type": "Education",
      "poi_address": "4025 E Northern Lights Blvd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1686-75fc-9135-881d67895b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1686-75fc-9135-881d67895b07",
        "storage_key": "property/6767906449167167/01a140ac-1686-75fc-9135-881d67895b07.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://east.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10928690134336071192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bettye-davis-east-anchorage-high-school",
      "poi_latitude": "61.199699499999994",
      "poi_longitude": "-149.8068662",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-742-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO1vJJfiWyFYRGOZqRcaBqpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0223ce95-6412-45e7-8a51-2b4c54f5b660",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Trailside Elementary School",
      "poi_type": "Education",
      "poi_address": "5151 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1505-7728-9c20-12077f05e5f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1505-7728-9c20-12077f05e5f2",
        "storage_key": "property/6767906449167167/01a140ac-1505-7728-9c20-12077f05e5f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://trailside.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=200225436096978114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trailside-elementary-school",
      "poi_latitude": "61.1394867",
      "poi_longitude": "-149.7875986",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-742-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtTOLaauQyFYRwtyOKflXxwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a227190c-1100-4c76-908f-4071339bd658",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Abbott Loop Elementary School",
      "poi_type": "Education",
      "poi_address": "8427 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-14ff-71e2-90ca-5fdcd3180ec8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-14ff-71e2-90ca-5fdcd3180ec8",
        "storage_key": "property/6767906449167167/01a140ac-14ff-71e2-90ca-5fdcd3180ec8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.asdk12.org/abbottloop",
      "poi_directions_map_url": "https://maps.google.com/?cid=688732736260866008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott-loop-elementary-school",
      "poi_latitude": "61.1439499",
      "poi_longitude": "-149.8331466",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-742-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE8yU9l-XyFYR2P8CSsbejgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_68118063-3529-47de-a45f-98432fd9e569",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Pacific Northern Academy",
      "poi_type": "Education",
      "poi_address": "2511 Sentry Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pacificnorthern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206734834740584442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-northern-academy",
      "poi_latitude": "61.1333745",
      "poi_longitude": "-149.8356213",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW969xGeWyFYR-l9pozx43gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_af3925e3-2a06-4aa6-8175-b42d2c7bcaaf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Little Pioneers Preschool",
      "poi_type": "Education",
      "poi_address": "9251 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-175b-72b6-b032-068d0c9c046c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-175b-72b6-b032-068d0c9c046c",
        "storage_key": "property/6767906449167167/01a140ac-175b-72b6-b032-068d0c9c046c.webp",
        "width": 390,
        "height": 292
      },
      "poi_business_url": "http://www.littlepioneers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7534421022883189973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-pioneers-preschool",
      "poi_latitude": "61.1366853",
      "poi_longitude": "-149.83370399999998",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-344-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE4euvCmZyFYR1RQwUQCkj2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f5ba585b-4449-426a-9a2f-6d6a00fbcd4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Children's Early Learning Center",
      "poi_type": "Education",
      "poi_address": "7231 Meadow St, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1878-75fa-b510-8e9b3fd03ab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1878-75fa-b510-8e9b3fd03ab3",
        "storage_key": "property/6767906449167167/01a140ac-1878-75fa-b510-8e9b3fd03ab3.webp",
        "width": 448,
        "height": 336
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9838522573530139429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-early-learning-center",
      "poi_latitude": "61.1546981",
      "poi_longitude": "-149.850869",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-336-3770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHRvcYnuXyFYRJQvtZSd0iYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b3de0c1e-9948-4395-96b4-98de115076ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Little Hands Preschool",
      "poi_type": "Education",
      "poi_address": "8201 Kip Ct, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18259183690727675010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-hands-preschool",
      "poi_latitude": "61.146391599999994",
      "poi_longitude": "-149.8161027",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvbMbNwCXyFYRgtRtTtOmZf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_6f732e45-013e-40c0-af95-456b943fc28e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Regal Dimond Center",
      "poi_type": "Entertainment",
      "poi_address": "800 E Dimond Blvd #201, Anchorage, AK 99515, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-bc0e-7026-a410-2f2018ca6f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-bc0e-7026-a410-2f2018ca6f02",
        "storage_key": "property/6767906449167167/019d021b-bc0e-7026-a410-2f2018ca6f02.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-dimond-center-cinemas-0922?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18078743811721282702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-dimond-center",
      "poi_latitude": "61.14334389999999",
      "poi_longitude": "-149.86803129999998",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff45-74cc-af9b-5a4f9c8821e7",
        "storage_key": "property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYRjkTwIraZ5Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_563b7ae8-2c09-4a7e-92de-12e80c7a7137",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-4ba3-70c8-85ec-e39466758f0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-4ba3-70c8-85ec-e39466758f0e",
        "storage_key": "property/6767906449167167/01a1404c-4ba3-70c8-85ec-e39466758f0e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff03-707f-8e43-6a2afd91887d",
        "storage_key": "property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c205f6da-1963-4bc4-b11f-0fbe14f3b4b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "621 W 6th Ave Suite ACPA, Anchorage, AK 99501, USA",
      "poi_short_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_long_description": "Large venue with 3 theaters hosting a range of events, from dance recitals to symphonies to plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-c09b-7658-b110-7dd0f9726985.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-c09b-7658-b110-7dd0f9726985",
        "storage_key": "property/6767906449167167/019d021b-c09b-7658-b110-7dd0f9726985.webp",
        "width": 1152,
        "height": 648
      },
      "poi_business_url": "https://www.alaskapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14135362058056830395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-center-for-the-performing-arts",
      "poi_latitude": "61.2170565",
      "poi_longitude": "-149.8943133",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-263-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-5159-70bd-97a3-a497b20fed19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-5159-70bd-97a3-a497b20fed19",
        "storage_key": "property/6767906449167167/01a140ac-5159-70bd-97a3-a497b20fed19.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcZ2Uoe9yFYRuw0DQubkKsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_7b9cc918-c55c-48c5-901b-488e5658c070",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1c0c-737a-81d7-b328611e1a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1c0c-737a-81d7-b328611e1a00",
        "storage_key": "property/6767906449167167/01a140ac-1c0c-737a-81d7-b328611e1a00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff45-74cc-af9b-5a4f9c8821e7",
        "storage_key": "property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_70d3146d-9b93-4dbe-b38b-e96110080ce5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ba59-763a-8efe-8fc006311937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-ba59-763a-8efe-8fc006311937",
        "storage_key": "property/6767906449167167/019d021b-ba59-763a-8efe-8fc006311937.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff03-707f-8e43-6a2afd91887d",
        "storage_key": "property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_9f650c33-ee71-403a-b9bf-959832e4785a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Wendy Williamson Auditorium (WWA)",
      "poi_type": "Entertainment",
      "poi_address": "2533 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Spacious university auditorium hosting diverse theater performances with stadium-style seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1c1b-767b-be10-fd1f2ae9e72e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1c1b-767b-be10-fd1f2ae9e72e",
        "storage_key": "property/6767906449167167/01a140ac-1c1b-767b-be10-fd1f2ae9e72e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.uaa.alaska.edu/wendy-williamson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15871697652609034219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendy-williamson-auditorium-wwa",
      "poi_latitude": "61.18871449999999",
      "poi_longitude": "-149.8331762",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-786-6881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-5165-73ff-84e4-4fff715dd03c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-5165-73ff-84e4-4fff715dd03c",
        "storage_key": "property/6767906449167167/01a140ac-5165-73ff-84e4-4fff715dd03c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-f2fKmXyFYR66cpVuyYQ9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_b803f525-bdff-4259-9ad1-8eddb1cf6376",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "E Street Theater",
      "poi_type": "Entertainment",
      "poi_address": "315 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-2a74-7502-a140-006617ad2ca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-2a74-7502-a140-006617ad2ca6",
        "storage_key": "property/6767906449167167/01a140ac-2a74-7502-a140-006617ad2ca6.webp",
        "width": 953,
        "height": 1280
      },
      "poi_business_url": "http://www.estreettheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11563790755098110231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-street-theater",
      "poi_latitude": "61.219055299999994",
      "poi_longitude": "-149.8911614",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-277-4545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff45-74cc-af9b-5a4f9c8821e7",
        "storage_key": "property/6767906449167167/019d021b-ff45-74cc-af9b-5a4f9c8821e7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SfTeIe9yFYRF6mRlmzWeqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_1bb639be-1184-4e05-8896-a6c4d1e720c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Cyrano's Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "3800 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_long_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-1ad0-72df-896f-5e2d0f0dafda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-1ad0-72df-896f-5e2d0f0dafda",
        "storage_key": "property/6767906449167167/01a140ac-1ad0-72df-896f-5e2d0f0dafda.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cyranos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374691035069826416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyranos-theatre-company",
      "poi_latitude": "61.2092959",
      "poi_longitude": "-149.80971449999998",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-274-2599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-5159-70bd-97a3-a497b20fed19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-5159-70bd-97a3-a497b20fed19",
        "storage_key": "property/6767906449167167/01a140ac-5159-70bd-97a3-a497b20fed19.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9JAzimWyFYRcEXwXaJynLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_c40ddc0b-d300-47a9-8525-f909a6b2cf62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Humpy's Great Alaskan Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "610 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_long_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-373d-7226-91f6-cf11c90107b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-373d-7226-91f6-cf11c90107b4",
        "storage_key": "property/6767906449167167/019d021c-373d-7226-91f6-cf11c90107b4.webp",
        "width": 904,
        "height": 720
      },
      "poi_business_url": "https://www.humpysalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2859243613023281808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "humpys-great-alaskan-alehouse",
      "poi_latitude": "61.216342",
      "poi_longitude": "-149.894083",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-276-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f648-740e-8497-b91827b232cf",
        "storage_key": "property/6767906449167167/019d021b-f648-740e-8497-b91827b232cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14LWxYC9yFYRkKKOyOoSric",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fd3512b0-0db5-4f23-b2d0-2b9c18167ecc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Bowling at Destination Dimond",
      "poi_type": "Entertainment",
      "poi_address": "800 E Dimond Blvd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-2a1c-7269-8f12-02087d3a4aa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-2a1c-7269-8f12-02087d3a4aa4",
        "storage_key": "property/6767906449167167/01a140ac-2a1c-7269-8f12-02087d3a4aa4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dimondcenter.com/stores/bowling-at-destination-dimond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16676496414033310481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowling-at-destination-dimond",
      "poi_latitude": "61.14235349999999",
      "poi_longitude": "-149.8678564",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-344-1544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwSSWNCZyFYREfOH-CHRbuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_d1ac888f-a4c7-4aed-b84e-641a13729bd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-5cf8-762f-89ca-9e217cc17c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-5cf8-762f-89ca-9e217cc17c6d",
        "storage_key": "property/6767906449167167/01a1404c-5cf8-762f-89ca-9e217cc17c6d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.82213539999998",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ffd6-7699-9c57-cba22e975727",
        "storage_key": "property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_eda988f9-8d12-402a-9c8f-f44f1e632537",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-e8d0-73d3-9d66-31c230bc1b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e8d0-73d3-9d66-31c230bc1b1b",
        "storage_key": "property/6767906449167167/019d021b-e8d0-73d3-9d66-31c230bc1b1b.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ffd6-7699-9c57-cba22e975727",
        "storage_key": "property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7b8598c8-bad6-4c02-aac2-b01b8f9fdd73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-c19c-744a-8df5-594a400a625c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-c19c-744a-8df5-594a400a625c",
        "storage_key": "property/6767906449167167/019d021b-c19c-744a-8df5-594a400a625c.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.80024269999998",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ffd6-7699-9c57-cba22e975727",
        "storage_key": "property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1e8a9c4c-10db-468b-9d0a-1759aed0b1b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Providence ExpressCare - Huffman Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1389 Huffman Park Dr Suite 110, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-c5a5-7491-a3bf-5dbab9234cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-c5a5-7491-a3bf-5dbab9234cea",
        "storage_key": "property/6767906449167167/019d021b-c5a5-7491-a3bf-5dbab9234cea.webp",
        "width": 940,
        "height": 528
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/expresscare-huffman?Is=location&y_source=1_MTQ1MjA4MjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16232698285760051887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-expresscare---huffman-urgent-care",
      "poi_latitude": "61.1106758",
      "poi_longitude": "-149.8555908",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-227-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnzOfgxGZyFYRr_rRHBYhRuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f0c3b48d-2fc6-48b0-9d61-2272cfcd5a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "First Care Medical Centers, LLC.",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 Huffman Rd, Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-2c65-726a-a86a-98655b614b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-2c65-726a-a86a-98655b614b90",
        "storage_key": "property/6767906449167167/01a140ac-2c65-726a-a86a-98655b614b90.webp",
        "width": 1280,
        "height": 1161
      },
      "poi_business_url": "http://www.firstcareak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18398045366535381313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-care-medical-centers-llc",
      "poi_latitude": "61.1092051",
      "poi_longitude": "-149.85775089999998",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-345-1199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaf4z5qZyFYRQeHcqcj8Uv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d966ff1d-63d8-4661-8f1f-1d8a0a080872",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-325a-76ad-8ad0-8c6d25bae3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-325a-76ad-8ad0-8c6d25bae3f5",
        "storage_key": "property/6767906449167167/01a140ac-325a-76ad-8ad0-8c6d25bae3f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00656?cid=loc_70100656P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495041474996265144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "61.1358817",
      "poi_longitude": "-149.8385167",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-365-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-00df-752f-97d7-9ade47c8e22e",
        "storage_key": "property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQGYP-eZyFYRuOB8uNMo6uQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_82e994d8-937b-438a-8aac-4c583b14f51d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1725 Abbott Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-c7c1-71c7-9dc1-7f5e53ff9571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-c7c1-71c7-9dc1-7f5e53ff9571",
        "storage_key": "property/6767906449167167/019d021b-c7c1-71c7-9dc1-7f5e53ff9571.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/1725-abbott-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10353681321902893657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.1422505",
      "poi_longitude": "-149.84388959999998",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-339-2860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-00df-752f-97d7-9ade47c8e22e",
        "storage_key": "property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVcl7t6ZyFYRWWqeXU6qr48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_eba48eea-cf7c-4b0f-a565-b16a0bf2ffc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2550 E 88th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-3518-718c-a95f-8a3d9f81fec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-3518-718c-a95f-8a3d9f81fec6",
        "storage_key": "property/6767906449167167/01a140ac-3518-718c-a95f-8a3d9f81fec6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2550+e+88th+ave-anchorage-ak-99507/id=15654",
      "poi_directions_map_url": "https://maps.google.com/?cid=3207990187705393781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "61.140687099999994",
      "poi_longitude": "-149.8348565",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-349-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-00df-752f-97d7-9ade47c8e22e",
        "storage_key": "property/6767906449167167/019d021c-00df-752f-97d7-9ade47c8e22e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswTnYeCZyFYRdWIePRQShSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3d59babb-8164-425e-9e78-686b2b6244c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "The Alaska Club South Gym & Pool",
      "poi_type": "Health and Wellness",
      "poi_address": "10931 O'Malley Centre Dr, Anchorage, AK 99515, USA",
      "poi_short_description": "Full-service gym and family fitness center featuring an indoor water park and group exercise classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-4ca8-7790-b038-301b3e5a77f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-4ca8-7790-b038-301b3e5a77f7",
        "storage_key": "property/6767906449167167/019d021c-4ca8-7790-b038-301b3e5a77f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacsouth-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=4163032924643864625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-south-gym--pool",
      "poi_latitude": "61.121884099999995",
      "poi_longitude": "-149.85985929999998",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-344-6567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWflpD5WZyFYRMTCnZWMQxjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_66f32eba-342e-4872-aac8-0b5a7a087cc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Studio Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3841 W Dimond Blvd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-336f-738c-aeb5-f87b65b51282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-336f-738c-aeb5-f87b65b51282",
        "storage_key": "property/6767906449167167/01a140ac-336f-738c-aeb5-f87b65b51282.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://studioakhotyoga.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-studioakhotyoga-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10056814649077451196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-hot-yoga",
      "poi_latitude": "61.1379345",
      "poi_longitude": "-149.9508895",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-245-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm_v-y2mYyFYRvMk02qP7kIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_afa0c694-46ce-4cb4-b555-a5321210dc2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Sand Lake Public Access",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4646 W 80th Ave, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-375e-72f1-a0c7-dad4ec4ce262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-375e-72f1-a0c7-dad4ec4ce262",
        "storage_key": "property/6767906449167167/01a140ac-375e-72f1-a0c7-dad4ec4ce262.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16968067485313307393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-lake-public-access",
      "poi_latitude": "61.1483424",
      "poi_longitude": "-149.9664336",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpddsGQCZyFYRAZP0Knqveus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_941a53dc-1d01-414e-8666-e22187204ca8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Bancroft Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1497 Alpenhorn Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-388b-753d-8330-bf2a4b04f19e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-388b-753d-8330-bf2a4b04f19e",
        "storage_key": "property/6767906449167167/01a140ac-388b-753d-8330-bf2a4b04f19e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8274834841495366802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bancroft-park",
      "poi_latitude": "61.173691899999994",
      "poi_longitude": "-149.85519549999998",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87Y7OZ-XyFYRkmxbRnIe1nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_52031bc6-d63b-4107-9a36-56ae771f4752",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Abbott Loop Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8101 Elmore Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Community city park featuring extensive multi-purpose trails and recreational facilities including a playground and baseball fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-375a-73ab-852a-3f2c54739d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-375a-73ab-852a-3f2c54739d9f",
        "storage_key": "property/6767906449167167/01a140ac-375a-73ab-852a-3f2c54739d9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/Departments/parks/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9564194593061388731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abbott-loop-community-park",
      "poi_latitude": "61.147408600000006",
      "poi_longitude": "-149.801292",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbRib1CXyFYRu8EiIk_YuoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8c28d406-00a7-4cbd-9c00-92a20388210d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Campbell Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2365 E 48th Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "Urban park with scenic walking and biking trails, fishing access, and updated playgrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-d012-7329-a7e1-ea2edcd86394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-d012-7329-a7e1-ea2edcd86394",
        "storage_key": "property/6767906449167167/019d021b-d012-7329-a7e1-ea2edcd86394.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://anchorageparkfoundation.org/footer/completed-projects/campbell-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1172772302220400418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-park",
      "poi_latitude": "61.177450500000006",
      "poi_longitude": "-149.8370751",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7nDjQmXyFYRIpdD_DGGRhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_03cd8236-ee79-4c33-9a28-224ce349dbf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-5e8b-729a-877d-7197346dbf3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-5e8b-729a-877d-7197346dbf3b",
        "storage_key": "property/6767906449167167/01a1404c-5e8b-729a-877d-7197346dbf3b.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-7b55-72d9-ac37-7b8417eb3bb5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1404c-7b55-72d9-ac37-7b8417eb3bb5",
        "storage_key": "property/6767906449167167/01a1404c-7b55-72d9-ac37-7b8417eb3bb5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7a779909-a0fd-4eb7-930a-720ce432956f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "University Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4050 University Lake Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Scenic lakeside dog park with walking trails and swimming areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-3ccb-7488-a43e-8332dfa140f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-3ccb-7488-a43e-8332dfa140f7",
        "storage_key": "property/6767906449167167/01a140ac-3ccb-7488-a43e-8332dfa140f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14589859302453206728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-lake-park",
      "poi_latitude": "61.1848311",
      "poi_longitude": "-149.8077434",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_rUugKXyFYRyN6mNbyXeco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_11d43c3b-574e-4182-a890-c8fc0d8ae139",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Campbell Creek Science Center",
      "poi_type": "Entertainment",
      "poi_address": "5600 Science Center Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "Interactive educational center for kids, with science exhibits and nature treks, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-3db4-72c0-a371-f638041b2e64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-3db4-72c0-a371-f638041b2e64",
        "storage_key": "property/6767906449167167/01a140ac-3db4-72c0-a371-f638041b2e64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.blm.gov/learn/interpretive-centers/campbell-creek-science-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2738030936295452035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-creek-science-center",
      "poi_latitude": "61.1641914",
      "poi_longitude": "-149.7769605",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-621-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ff03-707f-8e43-6a2afd91887d",
        "storage_key": "property/6767906449167167/019d021b-ff03-707f-8e43-6a2afd91887d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxMQgkmXyFYRg63rPaFw_yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d5cf2e30-dc77-4afe-bf3a-4586af477cdc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Wickersham Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1470 Cache Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-3d99-747c-a218-7e7ca44f88c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-3d99-747c-a218-7e7ca44f88c2",
        "storage_key": "property/6767906449167167/01a140ac-3d99-747c-a218-7e7ca44f88c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5141913036593338400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wickersham-park",
      "poi_latitude": "61.17644769999999",
      "poi_longitude": "-149.8457917",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZYA186CXyFYRIJgY7Km-W0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f895522c-61b2-4a6e-86fd-0fe74903f30b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Turinski Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6729 Lake Otis Pkwy, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212258978164274412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "turinski-park",
      "poi_latitude": "61.160330599999995",
      "poi_longitude": "-149.8325809",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3eJAsm-XyFYR7HRiZLuE2H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7ee2f283-ae39-44ac-a3b0-8b93dbedd75b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Far North Bicentennial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4970 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_long_description": "Popular 4,000-acre park with 100-plus miles of multi-use trails, skiing, a botanical garden & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-42ad-74ac-a1b6-84b2f2f92875.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-42ad-74ac-a1b6-84b2f2f92875",
        "storage_key": "property/6767906449167167/01a140ac-42ad-74ac-a1b6-84b2f2f92875.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1862495611458923156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "far-north-bicentennial-park",
      "poi_latitude": "61.1559064",
      "poi_longitude": "-149.75146490000003",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-061f-7749-9197-d12ec7775a62",
        "storage_key": "property/6767906449167167/019d021c-061f-7749-9197-d12ec7775a62.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2OHIzSXyFYRlKq7BOTp2Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_31cf8269-feba-4f5e-92d2-78592a19b435",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-3f3a-7659-ab76-59563ed1e619.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-3f3a-7659-ab76-59563ed1e619",
        "storage_key": "property/6767906449167167/01a140ac-3f3a-7659-ab76-59563ed1e619.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f2619565-2af7-41f4-b825-6149c6255f69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-430b-766e-a2c3-5902032bfdbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-430b-766e-a2c3-5902032bfdbf",
        "storage_key": "property/6767906449167167/01a140ac-430b-766e-a2c3-5902032bfdbf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-517f-713e-aba4-140ae3777a86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-517f-713e-aba4-140ae3777a86",
        "storage_key": "property/6767906449167167/01a140ac-517f-713e-aba4-140ae3777a86.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_46060563-d070-4d71-a9d5-557be141e065",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Muldoon & DeBarr w SSW",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4675355530867655016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muldoon--debarr-w-ssw",
      "poi_latitude": "61.2084857",
      "poi_longitude": "-149.73377929999998",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-517f-713e-aba4-140ae3777a86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a140ac-517f-713e-aba4-140ae3777a86",
        "storage_key": "property/6767906449167167/01a140ac-517f-713e-aba4-140ae3777a86.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJR83PtbyWyFYRaEEGkBUz4kA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_4deb321a-4c36-4a17-8396-473fa4e18571",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-6699-7513-9595-5a19564d265a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-6699-7513-9595-5a19564d265a",
        "storage_key": "property/6767906449167167/01a1404c-6699-7513-9595-5a19564d265a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901898",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-0658-7101-9935-e5f52d8be879.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-0658-7101-9935-e5f52d8be879",
        "storage_key": "property/6767906449167167/019d021c-0658-7101-9935-e5f52d8be879.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_60f47e51-582c-4b49-a45d-f034cf05bf45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-644e-77d8-ad47-c921c58eb7ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-644e-77d8-ad47-c921c58eb7ab",
        "storage_key": "property/6767906449167167/01a1404c-644e-77d8-ad47-c921c58eb7ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-0655-736f-8485-17e6409da439.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-0655-736f-8485-17e6409da439",
        "storage_key": "property/6767906449167167/019d021c-0655-736f-8485-17e6409da439.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_dd91104a-005a-4bbe-920d-8a0f6a721b20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "People Mover",
      "poi_type": "Transportation & Transit",
      "poi_address": "3600 Doctor M.L.K. Jr Ave, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-471c-7795-9be4-0f3a03b902a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-471c-7795-9be4-0f3a03b902a4",
        "storage_key": "property/6767906449167167/01a140ac-471c-7795-9be4-0f3a03b902a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14529945198539884947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "people-mover",
      "poi_latitude": "61.177075599999995",
      "poi_longitude": "-149.8139324",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-343-8402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-f66f-76be-9621-e09c82c325af",
        "storage_key": "property/6767906449167167/019d021b-f66f-76be-9621-e09c82c325af.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzSp6ChCXyFYRk8nc1Cy8pMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_640b7bb4-eb6e-40ef-9fe4-7e93220f3c40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-b3bf-73ac-b7b7-9d9a491c1a26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-b3bf-73ac-b7b7-9d9a491c1a26",
        "storage_key": "property/6767906449167167/019d021b-b3bf-73ac-b7b7-9d9a491c1a26.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.81955979999998",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b1a7eddc-a044-45e6-98c2-a6a924df3a9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "JBER Public Affairs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10480 Sijan Ave, Anchorage, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jber.jb.mil/Services-Resources/Public-Affairs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18373584563523412467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jber-public-affairs",
      "poi_latitude": "61.2471852",
      "poi_longitude": "-149.80933059999998",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-552-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-066f-7408-9797-a33cdc9c5394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-066f-7408-9797-a33cdc9c5394",
        "storage_key": "property/6767906449167167/019d021c-066f-7408-9797-a33cdc9c5394.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVGywKKVyFYR8-FpJ9AV_P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_ffd9d0f7-acee-4dd8-8d85-225447c452d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-e8a2-721f-9a29-60ebbea2ff84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021b-e8a2-721f-9a29-60ebbea2ff84",
        "storage_key": "property/6767906449167167/019d021b-e8a2-721f-9a29-60ebbea2ff84.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.184003999999995",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ffd6-7699-9c57-cba22e975727",
        "storage_key": "property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_ba807187-1cdb-47c4-a0e3-ffa34b5d5824",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Anchorage VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-4889-7278-835d-ae991dda5e32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-4889-7278-835d-ae991dda5e32",
        "storage_key": "property/6767906449167167/01a140ac-4889-7278-835d-ae991dda5e32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaska.va.gov/locations/directions.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1810043390262328329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-va-medical-center",
      "poi_latitude": "61.23270319999999",
      "poi_longitude": "-149.7444828",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-353-7574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-ffd6-7699-9c57-cba22e975727",
        "storage_key": "property/6767906449167167/019d021b-ffd6-7699-9c57-cba22e975727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYzvJi-UyFYRCTyhmN-QHhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a951f57f-bfae-4498-bbd9-d1c2c479a012",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a140ac-49b3-7600-9a07-cdbc266fbc61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a140ac-49b3-7600-9a07-cdbc266fbc61",
        "storage_key": "property/6767906449167167/01a140ac-49b3-7600-9a07-cdbc266fbc61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.193963100000005",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021b-fbcf-7268-82c0-8654f36728d6",
        "storage_key": "property/6767906449167167/019d021b-fbcf-7268-82c0-8654f36728d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7148e41c-f2f4-435f-bff1-a23733cc9d6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/01a1404c-6bce-76f6-9b22-2f1da5538120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1404c-6bce-76f6-9b22-2f1da5538120",
        "storage_key": "property/6767906449167167/01a1404c-6bce-76f6-9b22-2f1da5538120.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.216329900000005",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-066f-7408-9797-a33cdc9c5394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021c-066f-7408-9797-a33cdc9c5394",
        "storage_key": "property/6767906449167167/019d021c-066f-7408-9797-a33cdc9c5394.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f4e1b4d4175b74cdf38fba75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b9f09e2abdebaa4884172297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_89a71376fdf1efe298952e9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c0a2043fa28be341ef781154",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_261bc5296e30599fa64ceb04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d05ebdedcfcc97ee8ae6c392",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "rating": "5",
      "name": "Anastasiya C",
      "text": "We had an excellent experience with our maintenance manager, Connor. He came to check our washer after it started leaking, and thanks to him we were able to upgrade to a brand-new washer in less than three days.\n\nConnor handled everything incredibly fast — the installation took less than one hour, and everything works perfectly. He was professional, efficient, and very easy to work with.\n\nThis has been the best maintenance experience we’ve had, and we really appreciate his quick response and great service.",
      "date": "2026-02-10",
      "title": "false"
    },
    {
      "id": "ec_8df7ffaddc77bc39688b4ae3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "rating": "5",
      "name": "P. Gase",
      "text": "The Alpine Apartments staff brought joy to our world this holiday season! They provided Christmas gift wrapping services for me and my children. The experience was amazing, fun, seamless, convenient and stress free from start to finish. The staff were friendly, professional, and they even offered coffee and hot chocolate! Thank you so much for inviting us to be a part of your holiday traditions. Happy holidays!",
      "date": "2025-12-24",
      "title": "false"
    },
    {
      "id": "ec_8d697525c15f9dd0f1c15db7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "rating": "5",
      "name": "A",
      "text": "The maintenance worker James is very attentive and polite. He replaced the broken parts in my apartment instead of just doing a quick fix, always appreciated!! And the work order was attended to and completed nice and quickly.",
      "date": "2025-08-29",
      "title": "false"
    },
    {
      "id": "ec_4a893ebfb9daf6298a600351",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "rating": "5",
      "name": "Mux.llary A.A",
      "text": "I’m currently in the process of moving to Anchorage due to my husband being in the Army and I’m trying to get everything in order so this move can go smoothly. I applied to 5 other apartments in the anchorage area and all of them were super rude and non cohesive. Alpine was the only apartments that communicated with me effectively, stayed on top of things and they never give me attitude. Between Aret and James they were both super helpful in answering all my questions and NEVER made me feel like I was burden for asking questions about the apartments. Overall these apartments have been a green flag so far! I haven’t officially moved in yet but I hope it’s still a good experience after I move in",
      "date": "2025-08-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_5bd7e8cd69a774ff7deabc27",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-df76-713f-ba9f-636a089dfeb5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an empty apartment unit with a doorway to a bathroom, a closet, and a small kitchen counter area visible.",
        "public_id": "019d021c-df76-713f-ba9f-636a089dfeb5",
        "storage_key": "property/6767906449167167/019d021c-df76-713f-ba9f-636a089dfeb5.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=r4RbHrqXFYg"
    },
    {
      "id": "ec_0f1fcddd982891d37c9cdd54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019ddcf7-ccda-7424-bdb2-e98c136933ae.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf7-ccda-7424-bdb2-e98c136933ae",
        "storage_key": "property/6767906449167167/019ddcf7-ccda-7424-bdb2-e98c136933ae.webp",
        "width": 200,
        "height": 150
      },
      "virtual_tour_title": "One Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/491836227"
    },
    {
      "id": "ec_83e2a1618fd84ec244a63657",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-df1f-738b-919e-7c0a882cff40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen area with wooden cabinets, white appliances, and a sink, opening to a living area with carpet and large windows.",
        "public_id": "019d021c-df1f-738b-919e-7c0a882cff40",
        "storage_key": "property/6767906449167167/019d021c-df1f-738b-919e-7c0a882cff40.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Two Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=h3PcQaL4wR5"
    },
    {
      "id": "ec_6140f03d5c47879d0b09aa75",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167167/019d021c-e9c5-73b8-839d-1e6538861d41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living area with kitchen, dining area, and living room.",
        "public_id": "019d021c-e9c5-73b8-839d-1e6538861d41",
        "storage_key": "property/6767906449167167/019d021c-e9c5-73b8-839d-1e6538861d41.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Two Bedroom Furnished",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eH5Mqkut8v2"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d0bc-724f-9e14-86ccb61d00ef",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Alpine Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-anchorage",
      "search_query": "dog friendly apartments in Anchorage",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Anchorage",
      "h2_subtitle": "Discover dog friendly living at Alpine Apartments. Enjoy a welcoming community for both you and your furry friends in the heart of Anchorage.",
      "page_copy": "At Alpine Apartments, we understand the special bond between you and your pet. That's why we are proud to offer dog friendly apartments in Anchorage, providing a welcoming environment for the whole family. Nestled in the vibrant Campbell Park area, our community ensures that both you and your canine companion enjoy the best of apartment living. With many pet-friendly parks and trails nearby, you're never far from a fun day out with your pet.\n\nIn addition to our pet-friendly atmosphere, Alpine Apartments offers a wealth of amenities designed to simplify your lifestyle. From the convenience of online payments and service requests to our business center and Wifi cafe, you'll have everything you need right at your fingertips. And, to keep active, take advantage of our cardio machines! Join our Alpine community today and experience the ultimate in dog-friendly accommodations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Anchorage",
      "seo_description": "Explore Alpine Apartments' dog friendly options in Anchorage. Enjoy pet-friendly living with top amenities and easy access to nearby trails and parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "anchorage-apartments-with-fitness-center",
      "search_query": "Anchorage apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Anchorage Apartments with Fitness Center",
      "h2_subtitle": "Stay active at Alpine Apartments with our top-notch fitness center. Enjoy easy access to cardio machines right at home in Anchorage.",
      "page_copy": "Alpine Apartments offers Anchorage apartments with a fitness center designed for your active lifestyle. Located in the lively Campbell Park neighborhood, our community helps you maintain your fitness goals with convenience. You don't have to leave home to find top-notch equipment; our cardio machines are just steps away from your front door.\n\nNot only do we provide excellent fitness amenities, but our community also caters to a modern lifestyle with furnished units in select homes, a business center, and a Wifi cafe. Make your life simpler with online payments and service requests. Choose Alpine Apartments as your home and experience the balance of active living combined with comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Apartments with Fitness Center",
      "seo_description": "Discover Alpine Apartments' fitness center in Anchorage. Enjoy cardio machines and a modern lifestyle in the vibrant Campbell Park area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "furnished-apartments-campbell-park",
      "search_query": "furnished apartments in Campbell Park",
      "category": "Amenity",
      "h1_title": "Furnished Apartments in Campbell Park",
      "h2_subtitle": "Find comfort in our furnished apartments at Alpine Apartments. Experience modern living in the heart of Campbell Park, Anchorage.",
      "page_copy": "Alpine Apartments offers beautifully furnished apartments in Campbell Park, providing the ideal combination of convenience and comfort. Our select units come fully furnished, making moving in a breeze and allowing you to settle into your new Anchorage home effortlessly. Whether you're new to the area or seeking a hassle-free living experience, our furnished options cater to a variety of lifestyles.\n\nLocated in the vibrant neighborhood of Campbell Park, Alpine Apartments also provides residents with exceptional amenities like a business center and Wifi cafe, cardio machines for fitness enthusiasts, and easy online payments and service requests. The surrounding community offers abundant green spaces and the convenience of nearby shops and dining options. Discover the perfect furnished apartment with Alpine Apartments in Campbell Park today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Furnished Apartments in Campbell Park",
      "seo_description": "Explore Alpine Apartments' furnished living options in Campbell Park. Enjoy a seamless move-in experience with modern amenities in a vibrant Anchorage community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "anchorage-municipality-apartments-with-ac",
      "search_query": "Anchorage Municipality apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Anchorage Municipality Apartments with AC",
      "h2_subtitle": "Stay comfortable in our Anchorage Municipality apartments with air conditioning. Discover a refreshing living environment at Alpine Apartments.",
      "page_copy": "Experience comfort and convenience at Alpine Apartments, where our Anchorage Municipality apartments with air conditioning provide a refreshing escape from the outside elements. Nestled in the scenic Campbell Park, our community ensures a cozy and pleasant living environment no matter the weather. Air conditioning in select homes guarantees you stay cool during warm summer days.\n\nApart from climate-controlled interiors, Alpine Apartments also boasts a variety of modern amenities such as a business center, a Wifi cafe, and cardio machines for active residents. We make life easier with online payments and service requests. Live the balanced lifestyle you desire within our Anchorage Municipality community, where comfort and convenience go hand in hand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Anchorage Municipality Apartments with AC",
      "seo_description": "Discover air-conditioned living at Alpine Apartments in Anchorage Municipality. Enjoy comfort with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "anchorage-mountain-view-apartments",
      "search_query": "apartments with mountain views in Anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with Mountain Views in Anchorage",
      "h2_subtitle": "Enjoy breathtaking mountain views at Alpine Apartments in Anchorage. Experience scenic vistas from the comfort of your home.",
      "page_copy": "Alpine Apartments offers residents unparalleled apartments with mountain views in Anchorage, bringing natural beauty right to your window. Situated in the charming Campbell Park area, our community allows you to bask in the grandeur of Anchorage's stunning landscape every day. Wake up to awe-inspiring scenic views, making each morning a memorable experience.\n\nAlongside breathtaking vistas, Alpine Apartments features an array of modern amenities, including a Wifi cafe, business center, and cardio machines for those who enjoy staying active. With furnished units available in select homes and the convenience of online payments and service requests, living here combines beautiful surroundings with modern-day requirements. Discover an extraordinary living experience today at Alpine Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Mountain Views in Anchorage",
      "seo_description": "Alpine Apartments in Anchorage offers stunning mountain views. Enjoy modern amenities and scenic living in the heart of Campbell Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "anchorage-ak-studio-apartments",
      "search_query": "studio apartments anchorage ak",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Anchorage, AK",
      "h2_subtitle": "Discover the charm of studio apartments at Alpine Apartments in Anchorage, AK. Experience a cozy and convenient living environment.",
      "page_copy": "Alpine Apartments offers inviting studio apartments in Anchorage, AK, perfect for those seeking a cozy yet functional home. With a strategic location in Campbell Park, our studios provide a harmonious blend of efficiency and comfort tailored to modern lifestyles. Each studio features smart layouts designed to maximize space and provide a welcoming atmosphere.\n\nIn addition to well-designed living spaces, Alpine Apartments provides residents with essential amenities including a business center, Wifi cafe, and access to cardio machines. Select furnished units make moving easy, and with online payment options, managing your home is simple and stress-free. Make the most of Anchorage living by choosing a studio apartment that offers both convenience and community at Alpine Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Anchorage, AK",
      "seo_description": "Discover studio living at Alpine Apartments in Anchorage, AK. Enjoy a blend of cozy spaces and modern amenities in the Campbell Park neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "campbell-park-1-bedroom-apartments",
      "search_query": "1 bedroom apartments in campbell park",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Campbell Park",
      "h2_subtitle": "Explore spacious 1 bedroom apartments at Alpine Apartments in Campbell Park. Experience modern comfort and convenience in a vibrant community.",
      "page_copy": "Discover the ideal home at Alpine Apartments with our inviting 1 bedroom apartments in Campbell Park. These thoughtfully designed spaces offer a perfect mix of style and functionality, providing a comfortable living environment tailored to meet your needs. Located in the heart of Campbell Park, you’ll enjoy easy access to the beauty and activities that Anchorage has to offer.\n\nEach apartment features a range of amenities designed to enhance your lifestyle, including a business center, Wifi cafe, and cardio machines. With online payments and service requests, managing your apartment is both easy and convenient. Select homes also offer furnished options, making your move smoother. Make Alpine Apartments your new home and enjoy everything Campbell Park has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Campbell Park",
      "seo_description": "Find your ideal 1 bedroom apartment at Alpine Apartments in Campbell Park. Enjoy modern amenities and a convenient Anchorage location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "anchorage-municipality-two-bedroom-apartments",
      "search_query": "two bedroom apartments anchorage municipality",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Anchorage Municipality",
      "h2_subtitle": "Discover spacious living with two bedroom apartments at Alpine Apartments, nestled in the heart of Anchorage Municipality.",
      "page_copy": "Experience comfortable living with our two bedroom apartments in Anchorage Municipality at Alpine Apartments. These spacious residences are perfect for families or roommates seeking ample space without sacrificing proximity to all that Anchorage has to offer. Located in the inviting Campbell Park neighborhood, you’ll enjoy both tranquility and accessibility.\n\nAlpine Apartments not only provides generous living areas but also features a host of convenient amenities such as a business center, Wifi cafe, and cardio machines. Embrace the simplicity of online payments and service requests, ensuring your lifestyle remains stress-free. With select furnished units available, moving in is easier than ever. Elevate your residential experience with Alpine Apartments' two bedroom offerings in Anchorage Municipality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Anchorage Municipality",
      "seo_description": "Explore two bedroom apartments at Alpine Apartments in Anchorage Municipality, offering spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-near-uaa-campbell-park",
      "search_query": "apartments near University of Alaska Anchorage Campbell Park",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Find convenient living at Alpine Apartments near University of Alaska Anchorage, situated in Campbell Park's serene environment.",
      "page_copy": "Alpine Apartments offers the perfect home base for anyone looking for apartments near the University of Alaska Anchorage in the Campbell Park area. Our community provides a blend of comfort and convenience, ideal for students, faculty, or staff. Nestled in Campbell Park, you are minutes away from the University's campus, allowing you to enjoy suburban tranquillity while staying connected to campus life.\n\nResidents of Alpine Apartments benefit from a variety of amenities including a business center, a Wifi cafe, and cardio machines, catering to both study sessions and fitness routines. With the ease of online payments and service requests, apartment living becomes seamless. Select homes offer furnished options, providing a hassle-free move-in experience. Make Alpine Apartments your new home and relish the convenience of living near the University of Alaska Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Live near UAA! Discover Alpine Apartments in Campbell Park, offering convenience and modern amenities just minutes from the University.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center",
      "search_query": "apartments near alaska native medical center anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Discover Alpine Apartments, conveniently located near Alaska Native Medical Center in Anchorage, offering modern and comfortable living.",
      "page_copy": "Located in the vibrant community of Campbell Park, Alpine Apartments offers ideal housing options for those seeking apartments near Alaska Native Medical Center in Anchorage. Our community is perfectly positioned to provide easy access to the medical center, making it an excellent choice for healthcare professionals and patients alike.\n\nAlpine Apartments features a host of amenities to support a balanced lifestyle, including a business center, Wifi cafe, and cardio machines. With the flexibility of online payments and service requests, managing your living arrangements is simpler than ever. Select units even come furnished, easing the transition into your new home. Enjoy the blend of comfort and convenience at Alpine Apartments, just a short distance from the Alaska Native Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Explore Alpine Apartments near Alaska Native Medical Center in Anchorage. Enjoy modern amenities and a convenient location in Campbell Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-alaska-medical-center",
      "search_query": "apartments close to providence alaska medical center campbell park",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence Alaska Medical Center",
      "h2_subtitle": "Live comfortably at Alpine Apartments, just a short distance from Providence Alaska Medical Center in the Campbell Park area.",
      "page_copy": "Alpine Apartments provides an exceptional living experience for those looking for apartments close to Providence Alaska Medical Center in Campbell Park. Our location offers easy access to the medical center, making it an ideal place for healthcare professionals and those receiving treatment.\n\nEnjoy modern conveniences such as a business center, a Wifi cafe, and cardio machines right at home. The ability to make online payments and service requests ensures an effortless living experience. Some units also offer the convenience of being furnished, making your move-in process smooth. Experience the perfect combination of proximity and comfort at Alpine Apartments, nestled in the welcoming Campbell Park neighborhood near Providence Alaska Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Providence Alaska Medical Center",
      "seo_description": "Find comfortable living at Alpine Apartments near Providence Alaska Medical Center in Campbell Park, with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-near-earthquake-park-anchorage",
      "search_query": "apartments near Earthquake Park Anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Earthquake Park Anchorage",
      "h2_subtitle": "Discover Alpine Apartments, offering proximity to Earthquake Park in Anchorage with modern living amenities.",
      "page_copy": "If you're searching for apartments near Earthquake Park Anchorage, look no further than Alpine Apartments. Our community is situated just a short drive from the scenic Earthquake Park, providing both a peaceful retreat and access to Anchorage's natural beauty.\n\nAlpine Apartments combines convenience with comfort, offering a range of amenities like a business center, Wifi cafe, and cardio machines. With options such as online payments and service requests, daily living is made simple. Select homes come furnished, making relocation effort-free. Enjoy the perfect blend of nature and modern living at Alpine Apartments, close to Earthquake Park's trails and views.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Earthquake Park Anchorage",
      "seo_description": "Explore Alpine Apartments near Earthquake Park in Anchorage. Enjoy comfortable living with modern amenities and easy access to natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-close-to-alaska-botanical-garden",
      "search_query": "apartments close to Alaska Botanical Garden Campbell Park",
      "category": "Park",
      "h1_title": "Apartments Close to Alaska Botanical Garden",
      "h2_subtitle": "Experience Alpine Apartments, conveniently located near the Alaska Botanical Garden in Campbell Park.",
      "page_copy": "Nestled in Anchorage's Campbell Park neighborhood, Alpine Apartments offers an ideal home for those seeking apartments close to Alaska Botanical Garden. Our community's location provides easy access to the tranquil beauty of the garden, perfect for nature enthusiasts and relaxers alike.\n\nResidents enjoy a wide range of amenities, from a business center and Wifi cafe to cardio machines. Simplify your living with features like online payments and service requests, and select from furnished units if desired. Alpine Apartments harmonizes comfort and accessibility, offering an exceptional living experience close to the lush landscapes of the Alaska Botanical Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Alaska Botanical Garden",
      "seo_description": "Discover Alpine Apartments near the Alaska Botanical Garden in Campbell Park, Anchorage. Experience modern amenities and scenic proximity to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-by-delaney-park-anchorage",
      "search_query": "apartments by Delaney Park Anchorage Municipality",
      "category": "Park",
      "h1_title": "Apartments by Delaney Park Anchorage",
      "h2_subtitle": "Alpine Apartments offers modern living near Delaney Park within Anchorage Municipality, blending comfort with a central location.",
      "page_copy": "Discover the perfect blend of city convenience and serene park views at Alpine Apartments, located in the Anchorage Municipality near Delaney Park. Our community provides easy access to the vibrant surroundings and recreational areas of Delaney Park, making it an ideal choice for those who love the outdoors as much as urban living.\n\nAlpine Apartments caters to modern lifestyles with amenities such as a business center, Wifi cafe, and cardio machines. Ease your daily routines with online payments and service requests, while having the option of furnished units for a hassle-free setup. Experience an exceptional living environment near Delaney Park, where modern comforts meet natural beauty in Anchorage Municipality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Delaney Park Anchorage",
      "seo_description": "Choose Alpine Apartments by Delaney Park in Anchorage Municipality, offering modern amenities and proximity to scenic park areas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167167",
      "source": "generator",
      "page_item_url": "apartments-near-ted-stevens-anchorage-airport",
      "search_query": "apartments near Ted Stevens Anchorage Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Ted Stevens Anchorage Airport",
      "h2_subtitle": "Discover the convenience of Alpine Apartments, located close to Ted Stevens Anchorage Airport, offering modern amenities and a prime location.",
      "page_copy": "For those seeking apartments near Ted Stevens Anchorage Airport, Alpine Apartments offer an ideal location with unparalleled convenience. Perfect for frequent travelers and airport employees, our community ensures you're only a short ride away from the airport, while still nestled in the serene area of Campbell Park.\n\nAlpine Apartments boast exceptional amenities, including a business center and Wifi cafe, cardio machines, and easy online payments and service requests. Select homes even offer the convenience of being furnished, ideal for simplifying your move. Enjoy the perfect blend of proximity and comfort, making Alpine Apartments a great choice for access to Ted Stevens Anchorage Airport and the vibrant life of Anchorage.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ted Stevens Anchorage Airport",
      "seo_description": "Explore Alpine Apartments near Ted Stevens Anchorage Airport. Enjoy modern living with easy airport access and a range of amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309350761"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082962"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "e2860a25-2b83-42a2-ad96-1da9c89cfd9d"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/2ad71303-3a76-4ff9-a174-09771634cb5f/app.js?property=2ad71303-3a76-4ff9-a174-09771634cb5f&propertyName=Alpine&channelUuid=c248fb97-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47607381886"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ikg4RlBscFZkVjZXU1VKZjZLQ1k1WFE9PSIsInZhbHVlIjoia0NnMElyL0V4bERNTjlsdnJuUDA3Zz09IiwibWFjIjoiMmM3ZTMxODFlNWExZGE3MTVhODRmOGYxYmUyNDAzOTQyY2E3YTU0ODA0YzExM2ViMjIzZWRlYTllNDhkNzQ1ZSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309350761",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073082962",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "e2860a25-2b83-42a2-ad96-1da9c89cfd9d",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/2ad71303-3a76-4ff9-a174-09771634cb5f/app.js?property=2ad71303-3a76-4ff9-a174-09771634cb5f&propertyName=Alpine&channelUuid=c248fb97-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47607381886",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ikg4RlBscFZkVjZXU1VKZjZLQ1k1WFE9PSIsInZhbHVlIjoia0NnMElyL0V4bERNTjlsdnJuUDA3Zz09IiwibWFjIjoiMmM3ZTMxODFlNWExZGE3MTVhODRmOGYxYmUyNDAzOTQyY2E3YTU0ODA0YzExM2ViMjIzZWRlYTllNDhkNzQ1ZSJ9",
  "custom_audioeye_site_id": "a67c847a-8808-4290-a2ab-cfe8039c72d8",
  "custom_audioeye_site_hash": "a0241c8f605ae6fabd20b5c5f2eadeb1"
};

export const generatedAt = '2026-11-02T18:12:18.212Z';
